<template>
      <div class="cases-pagination-left">
        <div class="pagin-wrapp page-nav" v-if="all_pages.length>1">
          <div class="page-nav-prev" v-if="!isFirstPage" @click="setPage(curr_page - 1)">
            <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
              xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
              <defs>
                <clipPath id="ClipPath1018">
                  <path
                    d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                    fill="#ffffff"></path>
                </clipPath>
              </defs>
              <g>
                <g>
                  <g>
                    <path class="sssdf"
                      d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                      fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                      stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                      clip-path='url("#ClipPath1018")'></path>
                  </g>
                  <g>
                    <g>
                      <path class="sssdr" d="M37.11694,40.02775v0l-4.09639,-4.09664v0l4.09639,-4.09638v0"
                        fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray=""
                        stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41"
                        stroke-miterlimit="20" stroke-width="2"></path>
                    </g>
                    <g>
                      <path d="M40.30245,40.02775v0l-4.09651,-4.09664v0l4.09651,-4.09638v0" fill-opacity="0"
                        fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                        stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20"
                        stroke-width="2"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div class="page-nav-no">
            <div :class="{ 'curr-page': curr_page == 1 }" @click="setPage(1)">
              1
            </div>
          </div>
          <div class="page-nav-no" v-if="left_dots_visible">
            <div>
              ...
            </div>
          </div>
          <div class="page-nav-no" v-for="(str, key) in getLeftRightPages" :key="key" @click="setPage(str)">
            <div :class="{ 'curr-page': curr_page == str }">
              {{ str }}
            </div>
          </div>
          <div class="page-nav-no" v-if="right_dots_visible">
            <div>
              ...
            </div>
          </div>
          <div class="page-nav-no" v-if="all_pages.length>1">
          <div :class="{ 'curr-page': curr_page == all_pages.length }"
            @click="setPage(all_pages.length)">
            {{ all_pages.length }}
          </div>
          </div>
          <div class="page-nav-next" v-if="!isLastPage" @click="setPage(curr_page + 1)">
            <svg id="SVGDoc" width="71" height="72" xmlns="http://www.w3.org/2000/svg" version="1.1"
              xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 71 72">
              <defs>
                <clipPath id="ClipPath1043">
                  <path
                    d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                    fill="#ffffff"></path>
                </clipPath>
              </defs>
              <g>
                <g>
                  <g>
                    <path class="sssdf"
                      d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                      fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                      stroke-linecap="butt" stroke-opacity="1" stroke="#c2c2c2" stroke-miterlimit="20" stroke-width="2"
                      clip-path='url("#ClipPath1043")'></path>
                  </g>
                  <g>
                    <g>
                      >
                      <path class="sssdr" d="M33.88303,40.02775v0l4.09651,-4.09664v0l-4.09651,-4.09638v0"
                        fill-opacity="0" fill="#ffffff" stroke-dashoffset="0" stroke-dasharray=""
                        stroke-linejoin="miter" stroke-linecap="butt" stroke-opacity="1" stroke="#2b2b41"
                        stroke-miterlimit="20" stroke-width="2"></path>
                    </g>
                    <g>
                      <path d="M30.69751,40.02775v0l4.09663,-4.09664v0l-4.09663,-4.09638v0" fill-opacity="0"
                        fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                        stroke-linecap="butt" stroke-opacity="1" stroke="#f6eeff" stroke-miterlimit="20"
                        stroke-width="2"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
        <!-- <img style="width:16rem;" src="../assets/img/paginacija2.svg"> -->
      </div>
</template>

<script>
export default {
    props:['br_redova','ukupna_lista','finalni_arr_prikaza'],
    data() {
        return {
            all_pages: [],
            curr_page: 1,
            left_dots_visible: false,
            right_dots_visible: false,
        }
    },
    computed: {
        isFirstPage() {
            return this.curr_page == 1;
        },
        isLastPage() {
            return this.curr_page == this.all_pages[this.all_pages.length - 1];
        },
        getLeftRightPages() {
            // Init values
            let return_pages = []
            this.right_dots_visible = false;
            this.left_dots_visible = false;
            // Left of current page
            // 3 is the bottom value to make ... sense
            // LEFT LOOP
            let left_start = 2;
            let left_end = this.curr_page;
            if(this.curr_page == this.all_pages.length)
                left_end = this.curr_page-1;
            if (this.curr_page > 3) {
                left_start = this.curr_page - 1;
                this.left_dots_visible = true;
            }
            for (let j = left_start; j <= left_end; j++) {
                return_pages.push(j);
            }
            // RIGHT LOOP
            let right_start = this.curr_page + 1;
            if (right_start < this.all_pages.length)
                return_pages.push(right_start);
            if(right_start < this.all_pages.length-1)
            this.right_dots_visible = true;
            return return_pages
        },
    },
    watch: {
        curr_page: function () {
            this.paginirajOdabrane();
        },
    },
    methods: {
        setPage(pg) {
            this.curr_page = pg;
        },
        paginirajOdabrane() {
          if (this.curr_page > this.all_pages.length && this.all_pages.length>0) {
              this.curr_page = this.all_pages[this.all_pages.length-1];
          }
          let start_idx = 0 + this.br_redova * (this.curr_page - 1);
          let end_idx = this.br_redova * this.curr_page;
          this.$emit('update:finalni_arr_prikaza', this.ukupna_lista.slice(start_idx, end_idx))
        },
        calculatePageNumber() {
          this.all_pages = [];
          var finalni_broj = this.ukupna_lista.length / this.br_redova;
          if (this.ukupna_lista.length % this.br_redova >= 1) {
            finalni_broj++;
          }
          for (var i = 1; i <= finalni_broj; i++) {
            this.all_pages.push(i);
          }
          if (this.all_pages.length != 0) {
            this.curr_page = 1;
          }
          // console.log(finalni_broj);
        },
    },
}
</script>